'use client'
import React from "react";
import { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { NavLink } from "react-router-dom";
import Promotion from "../../../assets/home/home2.webp";
import "../../../pages/styles.css";
import { useSelector, useDispatch } from "react-redux";
import { loginModal } from "../../../Redux/authAction";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Main = () => {
  const dispatch = useDispatch();

  const isMainScreen = useMediaQuery({
    query: "(min-width: 860px)",
  });
  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );
  console.log("AUthenticated",isAuthenticated);


  const texts = ['Promotions.', 'Wedding Cards.','Birthday Cards.','Logo.','Resume.','Employee Certificates.','Cover Letter.'];
  const [index, setIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const [blink, setBlink] = useState(true);
  const [reverse, setReverse] = useState(false);
  const displayName = useSelector((state) => state.authReducer.displayName); // Moved outside
  console.log("my name is :",displayName);

  useEffect(() => {
    if (subIndex === texts[index].length + 1 && !reverse) {
      setTimeout(() => setReverse(true), 1000);
      return;
    }

    if (subIndex === 0 && reverse) {
      setReverse(false);
      setIndex((prev) => (prev + 1) % texts.length);
      return;
    }

    const timeout = setTimeout(() => {
      setSubIndex((prev) => prev + (reverse ? -1 : 1));
    }, Math.max(reverse ? 75 : subIndex === texts[index].length ? 1000 :
                150, parseInt(Math.random() * 350)));

    return () => clearTimeout(timeout);
  }, [subIndex, index, reverse]);

  useEffect(() => {
    const blinkTimeout = setTimeout(() => setBlink((prev) => !prev), 500);
    return () => clearTimeout(blinkTimeout);
  }, [blink]);

  return (
    <section>
      <div
        // style={{ backgroundImage:`url(${BG})`  }}

        className={`px-4 py-10 md:px-16 flex justify-between items-center bg-[] min-h-[calc(100vh-80px)] ${
          !isMainScreen ? "flex-col" : "flex-row"
        }`}
      >
        <div
          className={`flex flex-col justify-center items-start md:pr-20 ${
            !isMainScreen ? "items-center text-center" : ""
          } `}
          style={{ width: "clamp(300px,100%, 750px)" }}
        >
          <p
            className="text-[#2b2b2b] text-[18px] pb-[12px]"
            style={{
              fontFamily: "poppins",
              letterSpacing: "0.8px",
            }}
          >
            {" "}
            Your Premier Marketing Companion!{" "}
          </p>
          <p
            className={`text-[22px]  sm:text-[32px]  font-[600] text-[#262b33] leading-6 sm:leading-9`}
            style={{ fontFamily: "poppins" }}
          >
            Unleash your creativity  with{" "}
            <span
              className="text-[24px]  sm:text-[42px] font-[700] leading-[1.8] bg-gradient-to-r from-purple-500 via-purple-700 to-purple-800"
              style={{
                // background:
                //   "linear-gradient(to right, #714e91 0%, #5f619f  51%, #433761  100%)",
                backgroundClip: "text",
                color: "transparent",
                fontSize: "72px",
                fontFamily: "poppins",
              }}
            >
              Maker4U
            </span>
          </p>

          <p className={`text-[22px]  sm:text-[32px]  font-[600] text-[#262b33] leading-6 sm:leading-9`}
            style={{ fontFamily: "poppins" }}>
          You can make{' '}
          <span className="text-[#6D5294] inline-block">
            {`${texts[index].substring(0, subIndex)}${ '|' }`}
          </span>
        </p>
          <p
            className=" text-[#2B2B2B] text-[18px] pt-6 "
            style={{
              fontFamily: "poppins",
              letterSpacing: "0.5px",
            }}
          >
            Are you ready to take your brand to new heights? Maker4U is your
            All-in-one solution for creating magnetic promotional products,
            flawless editing, and stunning results that can spark your brand
            identification online. Stand out with polished, high-quality
            templates designed by experts.
          </p>
          <div className="flex text-2xl gap-5 mb-[30px] pt-8 justify-center items-center">
  <NavLink
    to="/ResumeMaker/temp/all"
    onClick={() => (isAuthenticated ? false : dispatch(loginModal(true)))}
    className="hover:no-underline focus:outline-none"
  >
    <button className="btn-grad focus:outline-none bg-gradient-to-r from-purple-600 via-purple-700 to-purple-800 text-white font-bold py-2 px-6 rounded-lg shadow-lg transform transition-transform hover:scale-105 hover:shadow-xl">
      Get Started
    </button>
  </NavLink>
  <NavLink
    to="/ResumeMaker/temp/all"
    onClick={() => (isAuthenticated ? false : dispatch(loginModal(true)))}
    className="hover:no-underline focus:outline-none"
  >
    <button className="btn-grad focus:outline-none bg-gradient-to-r from-purple-600 via-purple-700 to-purple-800 text-white font-bold py-2 px-6 rounded-lg shadow-lg transform transition-transform hover:scale-105 hover:shadow-xl">
      <div>Try Now</div>
    </button>
  </NavLink>
</div>

        </div>
        <div
          className=" h-[480px] overflow-hidden "
          style={{ width: "clamp(300px,100%,600px)" }}
        >
          <LazyLoadImage
            className="h-full w-full object-contain rounded-[16px]"
            alt="Main Image"
            height={500}
            src="/assets/herosection.png" // use normal <img> attributes as props
            width={500}
          />

          {/* <LazyLoadImage
            className="h-full w-full object-cover rounded-[16px]"
            alt="Main Image"
            height={350}
            src={`${Promotion}`} // use normal <img> attributes as props
            width={500}
          /> */}
          {/* <img
            src={`${Promotion}`}
            alt=""
            className="h-full w-full object-cover rounded-[16px]"
          /> */}
        </div>
      </div>
    </section>
  );
};

export default Main;
